import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import SidebarCollapseButton from './SidebarCollapseButton';

const SIDER_CHILDREN =
  '.mini-sidebar-toggle .ant-layout-sider-children, .mini-sidebar .ant-layout-sider-children';
const HOST_ID = 'leap-sidebar-footer-host';

/**
 * RFID-style sidebar footer (collapse) portaled into the Crema sider.
 */
export default function SidebarFooterPortal() {
  const [host, setHost] = useState(null);

  useEffect(() => {
    let cancelled = false;
    let observer;

    const ensureHost = () => {
      if (cancelled) return;
      const children = document.querySelector(SIDER_CHILDREN);
      if (!children) return false;

      let el = document.getElementById(HOST_ID);
      if (!el) {
        el = document.createElement('div');
        el.id = HOST_ID;
        el.className = 'leap-sidebar-footer';
        children.appendChild(el);
      }
      setHost(el);
      return true;
    };

    if (!ensureHost()) {
      observer = new MutationObserver(() => {
        if (ensureHost() && observer) observer.disconnect();
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }

    return () => {
      cancelled = true;
      observer?.disconnect();
    };
  }, []);

  if (!host) return null;

  return createPortal(
    <SidebarCollapseButton variant="footer" />,
    host
  );
}
